import { Cases } from "./Cases";

export const mt_cases = new Cases('mt');
export const sus_cases = new Cases('suspicious');